import { render, staticRenderFns } from "./CenteredLayout.vue?vue&type=template&id=b2ad1508&scoped=true&"
import script from "./CenteredLayout.vue?vue&type=script&lang=js&"
export * from "./CenteredLayout.vue?vue&type=script&lang=js&"
import style0 from "./CenteredLayout.vue?vue&type=style&index=0&id=b2ad1508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ad1508",
  null
  
)

export default component.exports